/**
 * region for libraries*/
import React, { Component } from "react";
import { Toolbar } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

/**
 * region for components*/
import HeaderTitle from '../../components/common/HeaderTitle';

/**
 * region for components*/
import InputSearchKeyword from "../../components/keyword/InputSearchKeyword";

/**
 * region for redux*/
import { connect } from "react-redux";

/**
 * region for styles*/
import { Fragment } from "react";
import { BrokenUrlResultActions } from "../../actions/BrokenUrlResultActions";
import typing from "../../helpers/typing";
const _ = require("lodash");

class HeaderBrokenUrls extends Component {

  state = {
    filters: "All Fields",
    filtersStatus: "0",
    searchTerm: "",
    currentFilter: "All Fields",
    currentStatusFilter: "All Status",
    filterTypes: [
      {
        id: "idCompany",
        name: "Company ID",
      },
      {
        id: "companyName",
        name: "Company Name",
      },
      {
        id: "url",
        name: "URL",
      },
    ],
    currentFilterStatusCode: "",
    dropdownOpenFilterStatusCode: false,
    dropdownOpenFilterTypes: false,
  };

    toggleFilterType() {
    this.setState({
      dropdownOpenFilterTypes: !this.state.dropdownOpenFilterTypes,
    });
  }

  toggleFilterStatusCode() {
    this.setState({
      dropdownOpenFilterStatusCode: !this.state.dropdownOpenFilterStatusCode,
    });
  }

  handleChangeTypeFilter(type, event) {
    event.preventDefault();
    const self = this;
    this.setState(
      {
        currentFilter: type.name,
        filters: type.id
      },
      () => {
        self.handleOnChangeSearchFilter();
      }
    );
  }

  handleChangeStatusFilter(type, event) {
    event.preventDefault();
    const self = this;
    this.setState(
      {
        currentStatusFilter: type.name,
        filtersStatus: type.id
      },
      () => {
        self.handleOnChangeSearchFilter();
      }
    );
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({
      searchTerm: event.target.value,
    });
  }

  onKeyPressSearchFilter(event) {
    const self = this;
    if (event.which === 13) {
      self.handleOnChangeSearchFilter(event);
    }
  }

  handleOnChangeSearchFilter() {
    var data = this.props.OriginalList;
    var filter = this.state.searchTerm;
    data = this.filterByStatusCode(data);
    if (!filter || filter.length === 0) {
      this.props.ListResult.data = data;
    } else {
      switch (this.state.filters) {
        case "idCompany":
          this.props.ListResult.data = data.filter((r) => r.IdFreeprofile.toString() === filter);
          break;
        case "companyName":
          this.props.ListResult.data = data.filter((r) => r.Company.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
          break;
        case "url":
          this.props.ListResult.data = data.filter((r) => r.Url.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
          break;
        case "All Fields":
        default:
          this.props.ListResult.data = data.filter(
            (r) => r.IdFreeprofile.toString() === filter || r.Company.toLowerCase().indexOf(filter.toLowerCase()) >= 0 || r.Url.toLowerCase().indexOf(filter.toLowerCase()) >= 0
          );
      }
    }
    this.props.fetchGetListFilter(this.props.ListResult);
    this.props.setPageListFilter(0);
  }

  filterByStatusCode(data) {
    var filterStatus = this.state.filtersStatus;
    if (filterStatus === "0") {
      return data;
    } else {
      return data.filter((r) => r.Status.toString() === filterStatus);
    }
  }

  getStatusCode(data) {
    var statusList = _.groupBy(data,"Status");
    var statusFilterList= Object.keys(statusList)
    .map(i => ({
        id: i,
        name: statusList[i][0].StatusString,
    }));
    return statusFilterList;
  }

  render() {
    let self = this;
    let loadingIsActive = false;
    let filterStatusCode = [];
    if (this.props.pending) {
      loadingIsActive = true;
    } else {
      loadingIsActive = false;

      if ( !typing.isEmpty(this.props.ListResult) && typing.isEmpty(this.props.OriginalList) && Object.keys(this.props.ListResult.data).length > 0 ) {
        var data = this.props.ListResult.data;
        this.props.setOriginalList(data);
      }
    }

    if (!typing.isEmpty(this.props.OriginalList) && Object.keys(this.props.OriginalList).length > 0 ){
      let statusCodeList = self.getStatusCode(this.props.OriginalList);
      filterStatusCode = statusCodeList.map((filterType) => (
        <DropdownItem key={filterType.id} className="dropdown-item" href="#" onClick={this.handleChangeStatusFilter.bind(this, filterType)}>
          {filterType.name}                                                                
        </DropdownItem>
      ));
    }

    let filterTypes = this.state.filterTypes.map((filterType) => (
      <DropdownItem key={filterType.id} className="dropdown-item" href="#" onClick={this.handleChangeTypeFilter.bind(this, filterType)}>
        {filterType.name}
      </DropdownItem>
    ));

    return (
      <Fragment>
        <Toolbar>
          <HeaderTitle
            title={"Broken Urls Reports"} />
          <div className="btn-group">
            <div className="btn-group">
              <InputSearchKeyword
                searchKeyword={this.state.searchTerm}
                handleChange={this.handleChange.bind(this)}
                onKeyPressSearchFilter={this.onKeyPressSearchFilter.bind(this)}
              />
            </div>
            <ButtonDropdown isOpen={this.state.dropdownOpenFilterTypes} toggle={this.toggleFilterType.bind(this)}>
              <DropdownToggle className="dropdown-toggle-border" caret>
                {this.state.currentFilter}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className="dropdown-item" href="#" onClick={this.handleChangeTypeFilter.bind(this, { id: "All Fields", name: "All Fields" })}>
                  All Types
                </DropdownItem>
                {filterTypes}
              </DropdownMenu>
            </ButtonDropdown>
            <ButtonDropdown isOpen={this.state.dropdownOpenFilterStatusCode} toggle={this.toggleFilterStatusCode.bind(this)}>
              <DropdownToggle className="dropdown-toggle-border" caret>
                {this.state.currentStatusFilter}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem className="dropdown-item" href="#" onClick={this.handleChangeStatusFilter.bind(this, { id: "0", name: "All Status" })}>
                  All Status
                </DropdownItem>
                {filterStatusCode}
              </DropdownMenu>
            </ButtonDropdown>
          </div>
        </Toolbar>
        <Backdrop open={loadingIsActive}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchGetListFilter: (list) => dispatch(BrokenUrlResultActions.fetchGetListFilter(list)),
    setPageListFilter: (page) => dispatch(BrokenUrlResultActions.setPageListFilter(page)),
    setOriginalList: (originalList) => dispatch(BrokenUrlResultActions.setOriginalList(originalList)),
  };
};

function mapStateToProps(state) {
  const pending = state.BrokenUrlResultReducers.pending;
  const ListResult = state.BrokenUrlResultReducers.ListResult;
  const OriginalList = state.BrokenUrlResultReducers.OriginalList;
  return {
    pending,
    ListResult,
    OriginalList,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)((HeaderBrokenUrls));
